function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useEffect, useState } from 'react';
import cn from 'classnames';
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import HomeSidebar, { getSidebarRoutes } from "../../components/NavigationAndStructure/HomeSidebar/HomeSidebar";
import { TopBar } from "../../components/NavigationAndStructure/TopBar";
import ErrorBoundaryPage from "../../components/ErrorBoundaryPage/ErrorBoundaryPage";
import { useOverlayContext, useStore, useStoreActions, useStoreStatic } from "../../contexts";
import { routes, defaultAuthorizedRoute } from "../../constants";
import InAppNotificationDrawer from "../../components/InAppNotificationsDrawer/InAppNotificationsDrawer";
import { LoginErrorModal } from "../../components/LoginErrorModal";
import { selectors } from "../../store/state-selectors";
import AgreementsDashboard from "../AgreementsDashboard/AgreementsDashboard";
import { ContactsDashboard, importContactsRoute } from "../ContactsDashboard";
import { DraftsDashboard } from "../DraftsDashboard";
import { AvailableAppsPage } from "../../integrations/AvailableAppsPage/AvailableAppsPage";
import InvoicesDashboard from "../InvoicesDashboard/InvoicesDashboard";
import PayoutsDashboard from "../PayoutsDashboard/PayoutsDashboard";
import { ProposalsDashboard } from "../ProposalsDashboard";
import { importServicesRoute, ServicesPage } from "../ServicesLibrary/ServicesPage/ServicesPage";
import VendorDashboard from "../VendorDashboard/VendorDashboard";
import ImportServices from "../ImportServices/ImportServices";
import ImportContacts from "../ImportContacts/ImportContacts";
import AgreementMinisite from "../AgreementMinisite/AgreementMinisite";
import ProfilePage from "../Profile/Profile";
import { BusinessDetails } from "../BusinessDetails";
import ProposalDefaults from "../ProposalDefaults/ProposalDefaults";
import TeamPage from "../TeamPage/TeamPage";
import AnchorBilling from "../AnchorBilling/AnchorBilling";
import ImportAgreements from "../ImportAgreements/ImportAgreements";
import GlobalBillingHub from "../GlobalBillingHub/GlobalBillingHub";
import VendorOnboardingModal from "../../components/VendorOnboardingModal/VendorOnboardingModal";
import { GoogleMapsProvider, loadGoogleMaps } from "../../components/AddressAutocomplete";
import FullPageInvoiceOpener from "../../components/FullPageInvoice/FullPageInvoiceOpener";
import HomePageProvider, { useHomePage } from "./HomePageProvider";
import ReferralDashboard from "../ReferralDashboard/ReferralDashboard";
import { ProposalTemplates } from "../ProposalTemplates/ProposalTemplates";
import { useQboInVob } from "../../components/VendorOnboardingModal/useQboInVob";
import { VobQboState } from "../../types/api.model";
import { userMenuRoutes } from "../../components/NavigationAndStructure/UserMenu/UserMenu";
import InAppNotificationBinder from "../../components/InAppNotificationsBinder";
import { withBlockPartiallyOnboardedVendor } from "../../components/withBlockPartiallyOnboardedVendor/withBlockPartiallyOnboardedVendor";
import { Reports } from "../Reports/Reports";
import NotificationSettings from "../NotificationSettings/NotificationSettings";
import RestfulWrapper from "../../components/RestfulWrapper/RestfulWrapper";
import { FullBox, useStateInRef } from 'seagull';
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { ArchivedProposalsDashboard } from "../ArchivedProposalsDashboard/ArchivedProposalsDashboard";
import { SecureLoginModal } from "../../components/SecureLoginModal/SecureLoginModal";
import APIKeysPage from "../APIKeysPage/APIKeysPage";
import ConnectedAppsPage from "../ConnectedAppsPage/ConnectedAppsPage";
import styles from "./HomePage.module.scss";
import { EnablePaymentsBanner, MissingColumnBankAccountBanner } from "./Banners";
import { BundlesPage } from "../ServicesLibrary/BundlesPage/BundlesPage";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const componentMountMap = [{
  url: routes.vendorDashboard,
  component: VendorDashboard
}, {
  url: routes.agreementsDashboard,
  component: AgreementsDashboard
}, {
  url: routes.proposalsDashboard,
  component: ProposalsDashboard
}, {
  url: routes.draftsDashboard,
  component: DraftsDashboard
}, {
  url: routes.archivedProposals,
  component: ArchivedProposalsDashboard
}, {
  url: routes.proposalTemplates,
  component: ProposalTemplates
}, {
  url: routes.proposalDefaults,
  component: ProposalDefaults
}, {
  url: routes.invoicesDashboard,
  component: InvoicesDashboard
}, {
  url: routes.payoutsDashboard,
  component: PayoutsDashboard
}, {
  url: routes.contacts,
  component: ContactsDashboard
}, {
  url: routes.serviceLibrary,
  component: ServicesPage
}, {
  url: routes.bundlesLibrary,
  component: BundlesPage
}, {
  url: routes.availableApps,
  component: AvailableAppsPage
}, {
  url: routes.notifications,
  component: NotificationSettings
}, {
  url: routes.profile,
  component: ProfilePage
}, {
  url: routes.businessDetails,
  component: BusinessDetails
}, {
  url: routes.team,
  component: TeamPage
}, {
  url: routes.anchorBilling,
  component: AnchorBilling
}, {
  url: routes.importAgreements,
  component: ImportAgreements
}, {
  url: routes.importServices,
  component: ImportServices
}, {
  url: routes.importContacts,
  component: ImportContacts
}, {
  url: routes.minisite(undefined),
  component: AgreementMinisite
}, {
  url: routes.globalBillingHub,
  component: GlobalBillingHub
}, {
  url: routes.referrals,
  component: ReferralDashboard
}, {
  url: routes.reports,
  component: Reports
}, {
  url: routes.anchorApiKeys,
  component: APIKeysPage
}, {
  url: routes.connectedApps,
  component: ConnectedAppsPage
}].reduce((map, _ref) => {
  let {
    url,
    component
  } = _ref;
  map[url] = withBlockPartiallyOnboardedVendor(component);
  return map;
}, {});
const appRoutes = [{
  id: 'minisite',
  text: '',
  url: routes.minisite(undefined),
  shouldShow: true
}];
export function ActualHomePage(props) {
  const {
    showModal,
    showSuccessToast
  } = useOverlayContext();
  const history = useHistory();
  const userInfo = useStore(state => state.userInfo);
  const {
    logBI
  } = useStoreActions();
  const {
    hidden
  } = useHomePage();
  const isVendor = useStore(selectors.user.isVendor);
  const {
    SET_IDENTITY_ONLY_TOKEN_FE,
    MANAGE_API_KEYS,
    CONNECTED_APPS_PAGE,
    SERVICE_TEMPLATE_BUNDLE
  } = useFeatureFlags();
  const pageLinks = useStore(selectors.filterAvailableRoutes(getSidebarRoutes({
    MANAGE_API_KEYS,
    CONNECTED_APPS_PAGE,
    SERVICE_TEMPLATE_BUNDLE
  }).concat(userMenuRoutes).concat(importContactsRoute).concat(importServicesRoute).concat(appRoutes)));
  const firstName = userInfo === null || userInfo === void 0 ? void 0 : userInfo.firstName();
  const lastName = userInfo === null || userInfo === void 0 ? void 0 : userInfo.lastName();
  const hasName = !!firstName && !!lastName;
  const isClient = userInfo === null || userInfo === void 0 ? void 0 : userInfo.isCustomer();
  const hasBusiness = !!(userInfo !== null && userInfo !== void 0 && userInfo.hasBusiness());
  const vobDone = hasName && hasBusiness;
  const isAnchorAdmin = useStore(selectors.user.isAnchorAdmin);
  const {
    getState: getVobQboState
  } = useQboInVob();
  const {
    getState
  } = useStoreStatic();
  const {
    showQboStep
  } = useQboInVob();
  const getEffectData = useStateInRef({
    getVobQboState
  });
  const isSetIdentityFlow = useStore(selectors.isSetIdentityFlow);
  const location = useLocation();
  const isOnLoginErrorRoute = location.pathname.includes(routes.loginError);
  const [secureLoginModalOpen, setSecureLoginModalOpen] = useState(false);
  const [secureLoginCompleted, setSecureLoginCompleted] = useState(false);
  useEffect(() => {
    // isSetIdentityFlow is true when the user has a business without an identity.
    // not showing SecureLoginModal if user is on login error route or if user already completed the flow
    if (isSetIdentityFlow && SET_IDENTITY_ONLY_TOKEN_FE && !isOnLoginErrorRoute && !secureLoginModalOpen && !secureLoginCompleted) {
      logBI(18900);
      setSecureLoginModalOpen(true);
      showModal({
        closeOnClickOutside: false,
        closeOnEscapeKey: false,
        content: _ref2 => {
          let {
            dismissModal
          } = _ref2;
          return /*#__PURE__*/_jsx(SecureLoginModal, {
            dismissModal: dismissModal,
            isDismissDisabled: true
          });
        }
      }).then(completed => {
        setSecureLoginModalOpen(false);
        if (completed) {
          setSecureLoginCompleted(true);
          showSuccessToast('Your secure login was set successfully', 'secure-login-set-success-toast');
        }
      });
    }
  }, [isSetIdentityFlow, SET_IDENTITY_ONLY_TOKEN_FE, isOnLoginErrorRoute, secureLoginModalOpen, secureLoginCompleted]);
  useEffect(() => {
    const openVOB = vobQboState => showModal({
      content: _ref3 => {
        let {
          dismissModal
        } = _ref3;
        return /*#__PURE__*/_jsx(GoogleMapsProvider, {
          loadGoogleMaps: loadGoogleMaps,
          children: /*#__PURE__*/_jsx(VendorOnboardingModal, {
            dismissModal: dismissModal,
            vobQboState: vobQboState,
            showQboStep: !!showQboStep
          })
        });
      },
      closeOnClickOutside: false,
      shouldBlurBackground: true
    });
    const {
      getVobQboState
    } = getEffectData();
    getVobQboState().then(vobQboState => {
      const isLinkedToQbo = selectors.integration.isLinkedToQbo(getState());
      const startedQboFlow = vobQboState === VobQboState.Started;
      const pendingQboSetup = vobQboState === VobQboState.ConnectionTriggered && isLinkedToQbo;
      if (!isClient && (!vobDone || (startedQboFlow || pendingQboSetup) && showQboStep)) {
        history.push(routes.vendorDashboard);
        openVOB(vobQboState).then(async finishedVOB => {
          if (!finishedVOB) openVOB(vobQboState);
        });
      }
    });
  }, [hasBusiness, isClient, showQboStep, vobDone]);
  function getAllNavigation(items) {
    return items.flatMap(item => 'url' in item ? item : 'items' in item ? getAllNavigation(item.items) : []);
  }
  return hidden ? null : /*#__PURE__*/_jsxs(FullBox, {
    flexDirection: "row",
    className: cn(styles.mainContainer, {
      [styles.anchorAdmin]: isAnchorAdmin
    }),
    "data-testid": "home-screen",
    children: [/*#__PURE__*/_jsx(FullPageInvoiceOpener, {}), /*#__PURE__*/_jsx(InAppNotificationDrawer, {}), /*#__PURE__*/_jsx(HomeSidebar, {}), /*#__PURE__*/_jsx(FullBox, {
      flexDirection: "column",
      className: styles.mainContent,
      children: /*#__PURE__*/_jsxs(FullBox, {
        flexDirection: "column",
        children: [/*#__PURE__*/_jsx(TopBar, {
          "data-testid": "topbar-home"
        }), /*#__PURE__*/_jsx(MissingColumnBankAccountBanner, {}), /*#__PURE__*/_jsx(EnablePaymentsBanner, {}), /*#__PURE__*/_jsx(ErrorBoundaryPage, {
          bounded: true,
          children: /*#__PURE__*/_jsxs(Switch, {
            children: [props.children, getAllNavigation(pageLinks).map(_ref4 => {
              let {
                url,
                exact
              } = _ref4;
              return /*#__PURE__*/_jsx(Route, {
                path: url,
                exact: exact,
                component: componentMountMap[url]
              }, url);
            }), /*#__PURE__*/_jsx(Redirect, {
              to: defaultAuthorizedRoute(isVendor)
            })]
          })
        }), /*#__PURE__*/_jsx(Route, {
          path: "*".concat(routes.loginError),
          render: () => /*#__PURE__*/_jsx(LoginErrorModal, {})
        })]
      })
    })]
  });
}
export default function HomePage(props) {
  const initialData = useStore(s => s.personaKYBStatus.data);
  const {
    fetchPersonaKYBStatus
  } = useStoreActions();
  return /*#__PURE__*/_jsx(RestfulWrapper, {
    initialData: initialData,
    fetch: fetchPersonaKYBStatus,
    renderChild: () => /*#__PURE__*/_jsxs(HomePageProvider, {
      children: [/*#__PURE__*/_jsx(InAppNotificationBinder, {}), /*#__PURE__*/_jsx(ActualHomePage, _objectSpread({}, props))]
    })
  });
}